var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFavorites = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    overflow: "scroll",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.239378,0,0,1.239378,-11.956933,-11.980871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "#333333",
    d: "m 51.1,21.6 c 4,-4.4 9.6,-6.4 15.2,-6.4 5.6,0 10.8,2.4 14.8,6.4 4,4.4 6.4,10 6.4,16 0,6 -2.4,11.6 -6.4,16 L 52.3,84.1 c -1.2,1.2 -3.2,1.2 -4.4,0 v 0 L 18.7,53.7 c -8.4,-8.8 -8.4,-23.2 0,-32 8.4,-8.8 21.6,-8.8 30,0 l 1.2,1.2 z m -1.2,55.3 23.2,-24.4 3.6,-3.6 c 2.8,-3.2 4,-7.2 4,-11.2 0,-4 -1.6,-8 -4.4,-11.2 C 73.6,23.6 70,22 66,22 62,22 58.4,23.6 55.6,26.4 L 51.9,30 c -0.8,1.6 -2.8,1.6 -4,0.4 v 0 l -3.6,-4 c -5.6,-6 -15.2,-6 -20.8,0 -5.6,6 -5.6,16 0,22 z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFavorites, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/favorites.64b9ebd4.svg";
export { ForwardRef as ReactComponent };